<div class="error-container my-5">
  <img class="error-container-img mb-5" src="assets/img/logo-zonder-tekst.jpg">
  <div class="error-container-text mb-5">
    <h1 class="error-header mb-3"><i>Oeps! Er is iets fout gegaan!</i></h1>
    <p>
      Dit onderdeel bestaat helaas (nog) niet.
      We zorgen ervoor dat het binnenkort wél werkt.
    </p>
    <p>
      Tot de volgende keer!
    </p>
    <button type="button" class="btn btn-back mt-2" tabindex="0" [routerLink]="['/home']">Terug naar home</button>
  </div>
</div>

